import React from "react";
import emailIcon from "../../images/icon/email-icon.svg";
import locationIcon from "../../images/icon/location-icon.svg";
import callIcon from "../../images/icon/call-icon.svg";
import "./ContactSection.css";

const ContactDetails: React.FC = () => {
  return (
    <div className="xb-contact-form xb-border">
      <div className="form-heading text-center mb-40">
        <h3 className="title">Ready to collaborate?</h3>
        <p className="sub-title" style={{ color: "var(--color-gray)" }}>
          Reach out to us directly using the details below.
        </p>
      </div>

      <div className="xb-contact-info-list">
        {/* Address Item */}
        <div className="xb-contact-info-item mb-30">
          <div className="info-icon">
            <img src={locationIcon} alt="Address" />
          </div>
          <div className="info-text">
            <span className="info-label">Our Office</span>
            <span className="info-val">
              60 West Main Street, Westminster MD 21157, United States
            </span>
          </div>
        </div>

        {/* Phone Item */}
        <div className="xb-contact-info-item mb-30">
          <div className="info-icon">
            <img src={callIcon} alt="Phone" />
          </div>
          <div className="info-text">
            <span className="info-label">Phone Number</span>
            <a href="tel:+14437477017" className="info-link">
              +1(443) 747-7017
            </a>
          </div>
        </div>

        {/* Email Item */}
        <div className="xb-contact-info-item">
          <div className="info-icon">
            <img src={emailIcon} alt="Email" />
          </div>
          <div className="info-text">
            <span className="info-label">Email Address</span>
            <a href="mailto:support@yesdi.com" className="info-link">
              support@yesdi.com
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactDetails;
